import React, { useState, useContext } from "react";
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  useToast,
  Skeleton,
} from "@chakra-ui/react";
import SupplierItem from "./SupplierItem";
import { useHistory } from "react-router-dom";
import { SuppliersContext } from "../Context/SuppliersContext";
import useFetch from "../../hooks/useFetch";
import ContentCard from "../Common/Layout/ContentCard";

const SuppliersList = () => {
  const history = useHistory();
  const { put } = useFetch();
  const [showNewSupplier, setShowNewSupplier] = useState(false);
  const { suppliers, isLoadingSuppliers, getSuppliers } =
    useContext(SuppliersContext);
  const toast = useToast();

  const handleDelete = async (supplier) => {
    await put(`/suppliers/${supplier.id}`, { active: 0 })
      .then(async (res) => {
        getSuppliers();
        toast({
          title: "Proveedor eliminado con éxito.",
          description: "Se ha eliminado el proveedor.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  return (
    <ContentCard>
      <Heading variant="h2">Proveedores</Heading>

      <Button
        my="2"
        colorScheme="blue"
        onClick={() => history.push("/proveedores/new")}
        //isDisabled={showNewSupplier}
      >
        + Proveedor
      </Button>

      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
          <Thead>
            <Tr>
              <Th fontSize="0.8em">Razón social</Th>
              <Th fontSize="0.8em">Dirección</Th>
              <Th fontSize="0.8em">CUIT</Th>
              <Th fontSize="0.8em">Celular</Th>
              <Th fontSize="0.8em" textAlign="right">
                Saldo
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoadingSuppliers ? (
              <Tr>
                <Td colSpan="100%">
                  <Skeleton h="1rem" />
                </Td>
              </Tr>
            ) : (
              <>
                {showNewSupplier && (
                  <SupplierItem
                    supplier={{}}
                    setShowNewSupplier={setShowNewSupplier}
                    initialAction={"new"}
                  />
                )}

                {suppliers.map((supplier) => (
                  <SupplierItem
                    key={supplier.id}
                    supplier={supplier}
                    setShowNewSupplier={setShowNewSupplier}
                    deleteSupplier={handleDelete}
                  />
                ))}
              </>
            )}
          </Tbody>
        </Table>
      </Box>
    </ContentCard>
  );
};

export default SuppliersList;
